import { UiSchema } from '@rjsf/utils'

import { HIDDEN_WIDGET, READONLY_WIDGET } from '../../../features/schema'

export function getUiSchema(): UiSchema {
  return {
    test: HIDDEN_WIDGET,
    models: HIDDEN_WIDGET,
    training: HIDDEN_WIDGET,
    stepNlpConfigurations: HIDDEN_WIDGET,
    otherDialog: { 'ui:widget': 'DialogCreatableSelectWidget' },
    noMatchDialog: { 'ui:widget': 'DialogCreatableSelectWidget' },
    controls: { ...READONLY_WIDGET, 'ui:widget': 'NlpControlsWidget' }
  }
}
